module.exports = __webpack_public_path__ + "static/img/noimg.7a59ef6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/News/NewsList/images/noimg.jpg
// module id = 24Gu
// module chunks = 1